import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { ref, onMounted } from 'vue'
import { api } from '@/services/api'

// todo aram move this to views folder, also maybe change the url to /activity instead of /activity-history

interface Activity {
  partitionKey: string
  rowKey: string
  timestamp: string
  eTag: string
  customerId: string
  activityType: string
  description: string
  performerName: string
  performerEmail: string
  performedAt: string
  additionalData: string
}


export default /*@__PURE__*/_defineComponent({
  __name: 'ActivityHistoryView',
  setup(__props) {

const activities = ref<Activity[]>([])
const loading = ref(false)

const headers = [
  { title: 'Date', key: 'performedAt', sortable: true },
  { title: 'Performer', key: 'performerName', sortable: true },
  { title: 'Activity Type', key: 'activityType', sortable: true },
  { title: 'Description', key: 'description', sortable: true }
]

const formatDate = (dateString: string) => {
  return new Date(dateString).toLocaleString()
}

const fetchActivities = async () => {
  loading.value = true
  try {
    const response = await api.getActivities()
    activities.value = response
  } catch (error) {
    console.error('Error fetching activities:', error)
  } finally {
    loading.value = false
  }
}

onMounted(() => {
  fetchActivities()
})

return (_ctx: any,_cache: any) => {
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_data_table = _resolveComponent("v-data-table")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createBlock(_component_v_container, null, {
    default: _withCtx(() => [
      _createVNode(_component_v_card, null, {
        default: _withCtx(() => [
          _createVNode(_component_v_card_title, null, {
            default: _withCtx(() => _cache[0] || (_cache[0] = [
              _createTextVNode("Activity History")
            ])),
            _: 1
          }),
          _createVNode(_component_v_card_text, null, {
            default: _withCtx(() => [
              _createVNode(_component_v_data_table, {
                headers: headers,
                items: activities.value,
                loading: loading.value,
                class: "elevation-1"
              }, {
                "item.performedAt": _withCtx(({ item }) => [
                  _createTextVNode(_toDisplayString(formatDate(item.performedAt)), 1)
                ]),
                _: 1
              }, 8, ["items", "loading"])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})